import { StarIcon } from "lucide-react";

import { Row } from "@/components/Row";
import { Button } from "@/components/ui/button";

import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";

export const StarRatingInput = ({
  onChange,
  value,
}: {
  onChange: (value: number) => void;
  value: number;
}) => {
  return (
    <Row className="items-center justify-center gap-1 p-2">
      {[1, 2, 3, 4, 5].map((score) => (
        <Button
          key={score}
          type="button"
          variant="ghost"
          className="p-1 [&_svg]:size-5"
          onClick={() => {
            mixpanelUtils.trackButtonClick(
              "Star rating clicked",
              getScreenFromPathname(location.pathname),
              { value: score },
            );
            onChange(score);
          }}
        >
          <StarIcon
            className={
              score <= value
                ? "fill-yellow-500 text-yellow-500"
                : "fill-slate-300 text-slate-300"
            }
          />
        </Button>
      ))}
    </Row>
  );
};
